<template>
  <div class="content__map">
    <ContentSearchBar />
    <div class="map-listing">
      <ContentListing v-if="store.getZoom > 7" />
      <GMapMap
        :center="store.getCenterPosition"
        :zoom="store.getZoom"
        map-type-id="roadmap"
        style="width: 100%; height: 600px"
        :options="options"
        ref="mapRef"
      >
        <GMapCluster :zoomOnClick="false">
          <gmap-custom-marker
            v-show="store.getZoom === 6"
            class="custom-poland-overlay"
            :marker="marker"
            :zIndex="0"
          >
            <img :alt="translateMap()" src="/themes/custom/link4/images/icons/poland.svg" />
          </gmap-custom-marker>
        </GMapCluster>

        <GMapCluster
          :zoomOnClick="true"
          :styles="clusterStyles"
          :minimumClusterSize="minimumClusterSize"
        >
          <GMapMarker
            :key="index"
            v-for="(m, index) in store.getContents"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            :icon="require('@/assets/map-pin.png')"
            @click="centerPosition(m.position)"
          />
        </GMapCluster>
      </GMapMap>
    </div>
  </div>
</template>
<script>
import ContentSearchBar from "./ContentSearchBar.vue";
import { useContentStore } from "@/store/content";
import { ref, watch, computed } from "vue";
import ContentListing from "../components/ContentListing.vue";
import GmapCustomMarker from "vue2-gmap-custom-marker";
export default {
  name: "ContentMap",
  components: {
    ContentSearchBar,
    ContentListing,
    "gmap-custom-marker": GmapCustomMarker,
  },
  setup() {
    //map stylings
    const marker = {
      lat: 48.1189046,
      lng: 19.1343786,
    };
    const clusterStyles = [
      {
        textColor: "white",
        url: require("@/assets/map-cluster.png"),
        height: 32,
        width: 32,
        textSize: 15,
        fontFamily: "Plus Jakarta Sans",
      },
    ];
    const mapStyles = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
    ];
    const mapStylesCloseUp = [
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            hue: "#6600ff",
          },
          {
            saturation: -11,
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            saturation: -78,
          },
          {
            hue: "#6600ff",
          },
          {
            lightness: -47,
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            hue: "#5e00ff",
          },
          {
            saturation: -16,
          },
        ],
      },
      {
        featureType: "transit.line",
        elementType: "all",
        stylers: [
          {
            saturation: -72,
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#f1dff1",
          },
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [
          {
            color: "#babdb6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            color: "#c4c6f4",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
          {
            color: "#d3d4f3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            color: "#000000",
          },
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            weight: "0.01",
          },
        ],
      },
    ];
    const store = useContentStore();

    const options = ref({
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: mapStyles,
      backgroundColor: "none",
      minZoom: 6,
      maxZoom: 18,
      restriction: {
        latLngBounds: {
          north: 55.3,
          south: 48.4,
          east: 25,
          west: 13.7,
        },
      },
    });
    const mapRef = ref();
    const showMapDetails = ref(false);
    const mobileMapLeftTransform = ref(0);
    const currentCenter = ref(0);
    const minimumClusterSize = computed(() => {
      return store.getZoom === 6 ? 1 : 2;
    });
    watch(mapRef, async (googleMap) => {
      try {
        if (googleMap) {
          googleMap.$mapPromise
            .then((map) => {
              map.addListener("zoom_changed", () => {
                if (map.getZoom() === 6) {
                  map.setCenter(store.polandCenter);
                }

                showMapDetails.value = map.getZoom() > 7 ? true : false;
                store.zoom = map.getZoom();
                options.value.styles =
                  map.getZoom() > 6 ? mapStylesCloseUp : mapStyles;
                store.setCurrentBounds(map.getBounds());
              });
              map.addListener("bounds_changed", () => {
                if (map.getZoom() > 7) {
                  store.setCurrentBounds(map.getBounds());
                  document.querySelector(".vue-map-container").style.width =
                    window.innerWidth > 768 ? "500px" : "100%";
                }
              });
              map.addListener("drag", () => {
                if (window.innerWidth < 768) {
                  currentCenter.value = map.getCenter().lng();
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log(err);
      }
    });
    watch(currentCenter, (currentCenter, prevCurrentCenter) => {
      if (prevCurrentCenter > currentCenter) {
        mobileMapLeftTransform.value += 4;
      } else {
        mobileMapLeftTransform.value -= 4.5;
      }
    });
    function centerPosition(position) {
      store.setCenterPosition(position);
      store.zoomIn();
    }
    function translateMap() {
      return window.Drupal.t("Map of Poland");
    }
    return {
      mapRef,
      clusterStyles,
      options,
      centerPosition,
      mapStyles,
      showMapDetails,
      store,
      translateMap,
      mobileMapLeftTransform,
      marker,
      minimumClusterSize,
    };
  },
};
</script>./ContentListing.vue@/store/content